import { PostFeedback } from "./ApiCalls/feedback/postFeedback";
import { GetFeedbacks } from "./ApiCalls/feedback/getFeedbacks";
import i18n from 'i18next';
import { addDaysAndFormat, formatToSpanishTimeZone } from "../utils/formatDate";

const authInfoString = localStorage.getItem("authInfo");

const authInfo = authInfoString ? JSON.parse(authInfoString) : {};

const user = authInfo.idUser;

export async function PostFeedbackService(feedback) {
  try {
    const key = await PostFeedback(feedback);

    return key;
  } catch (error) {
    // console.error("Error during login:", error);

    // Manejar el error

    throw error;
  }
}

export async function GetFeedbacksService() {
  try {
    const Feedbacks = await GetFeedbacks(user);

    const sortedFeedbacks = Feedbacks.sort((a, b) => {
      // Convertir las fechas a objetos Date para la comparación

      const dateA = new Date(a.createdAt);

      const dateB = new Date(b.createdAt);

      return dateB - dateA; // Orden descendente
    });

    const feedbackData = sortedFeedbacks.map((feedback) => {

      return {
        feedback: feedback.feedback1,

        createdAt: formatToSpanishTimeZone(feedback.createdAt),

        limitDateAd: addDaysAndFormat(feedback.createdAt, 7),

        company: feedback.companyName,

        companyId: feedback.company,

        username: feedback.username ? feedback.username : `${i18n.t("services:services.anonymous")}`,

        title: feedback.title,

        description: feedback.description,

      };
    });


    return feedbackData;
  } catch (error) {
    // Manejar el error

    throw error;
  }
}